import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { FiChecklist2ReportComponent } from '@fi-shared/checklist/fi-checklist2-report/fi-checklist2-report.component';
import { FiChecklist2ReportTimePeriodType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-time-period-type';
import { FiChecklist2ReportType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';

const ChecklistV2ReportState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2.Report._name,
    url: '/Report',
    abstract: true,
    component: FiAbstractStateComponent,
};

const ChecklistV2ReportDashboardState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2.Report.Dashboard,
    url: '/Dashboard',
    params: {
        reloadData: null,
        checklistId: null,
        scheduleId: null,
        reportType: null,
        timePeriodType: null,
        startDate: null,
        endDate: null,
        /*checklistId: 121, // for opening given report view from start
        scheduleId: 236,
        reportType: FiChecklist2ReportType.PastChecklists,
        timePeriodType: FiChecklist2ReportTimePeriodType.LastWeek,
        startDate: '2025-05-28T21:00:00.000Z',
        endDate: '2025-06-01T21:00:00.000Z',*/
    },
    component: FiChecklist2ReportComponent,
    reloadOnSearch: false,
    resolve: {
        //reloadData: [FiStateService, Transition, dashBoardState_reloadData],
    },
};

export const ChecklistV2ReportStates: StatesModule = {
    states: [ChecklistV2ReportState, ChecklistV2ReportDashboardState],
};

export function registerChecklistV2ReportStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.ChecklistV2.Report._name], {
        SettingType: [ApplicationSettingsType.ChecklistV2Reports],
        AccessType: AccessRightType.Read,
    });
    stateAccessCheckService.registerStateRules([FiStateNames.ChecklistV2.Report.Dashboard], {
        SettingType: [ApplicationSettingsType.ChecklistV2Reports],
        AccessType: AccessRightType.Read,
    });
}
